import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from './Logo';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navLinkClasses = ({ isActive }) =>
    `relative px-2 py-1 transition-colors duration-300 ${isActive ? "text-[#FF914D] font-medium" : "text-dark hover:text-[#FF914D]"
    }`;

  const mobileNavLinkClasses = ({ isActive }) =>
    `block px-4 py-2 text-lg transition-colors duration-300 ${isActive ? "text-[#FF914D] font-medium bg-orange-50" : "text-dark hover:text-[#FF914D] hover:bg-gray-50"
    }`;

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-white/90 backdrop-blur-md shadow-md py-2"
          : "bg-white/50 backdrop-blur-sm py-4"
        }`}
    >
      <div className="container flex items-center justify-between">
        <Logo />

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <NavLink to="/" className={navLinkClasses}>
            Home
            {({ isActive }) => isActive && (
              <motion.div
                layoutId="underline"
                className="absolute left-0 right-0 bottom-0 h-0.5 bg-[#FF914D]"
              />
            )}
          </NavLink>
          <NavLink to="/about" className={navLinkClasses}>
            About
            {({ isActive }) => isActive && (
              <motion.div
                layoutId="underline"
                className="absolute left-0 right-0 bottom-0 h-0.5 bg-[#FF914D]"
              />
            )}
          </NavLink>
          <NavLink to="/portfolio" className={navLinkClasses}>
            Portfolio
            {({ isActive }) => isActive && (
              <motion.div
                layoutId="underline"
                className="absolute left-0 right-0 bottom-0 h-0.5 bg-[#FF914D]"
              />
            )}
          </NavLink>
          <NavLink to="/contact" className={navLinkClasses}>
            Contact
            {({ isActive }) => isActive && (
              <motion.div
                layoutId="underline"
                className="absolute left-0 right-0 bottom-0 h-0.5 bg-[#FF914D]"
              />
            )}
          </NavLink>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-dark focus:outline-none p-2"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <div className="w-6 h-5 relative flex flex-col justify-between">
            <motion.span
              animate={isOpen ? { rotate: 45, y: 9 } : { rotate: 0, y: 0 }}
              className="w-full h-0.5 bg-dark block origin-center transition-transform"
            />
            <motion.span
              animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
              className="w-full h-0.5 bg-dark block transition-opacity"
            />
            <motion.span
              animate={isOpen ? { rotate: -45, y: -9 } : { rotate: 0, y: 0 }}
              className="w-full h-0.5 bg-dark block origin-center transition-transform"
            />
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100 overflow-hidden"
          >
            <div className="container py-4 space-y-2">
              <NavLink to="/" className={mobileNavLinkClasses} onClick={toggleMenu}>
                Home
              </NavLink>
              <NavLink to="/about" className={mobileNavLinkClasses} onClick={toggleMenu}>
                About
              </NavLink>
              <NavLink to="/portfolio" className={mobileNavLinkClasses} onClick={toggleMenu}>
                Portfolio
              </NavLink>
              <NavLink to="/contact" className={mobileNavLinkClasses} onClick={toggleMenu}>
                Contact
              </NavLink>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;